// Default sink (UAT-D-009): when reportWebVitals() is called without a
// callback (as index.js does), log each Core Web Vital to the console so the
// page-load baseline is observable in DevTools / the deployed app. Pass a
// custom function (e.g. a beacon) to override. web-vitals v1 API:
// getCLS / getFID / getFCP / getLCP / getTTFB.
const logMetric = ({ name, value, id }) => {
  // value: ms for LCP/FID/FCP/TTFB; unitless score for CLS.
  // eslint-disable-next-line no-console
  console.log(`[web-vitals] ${name}: ${Math.round(value * 1000) / 1000} (id=${id})`);
};

const reportWebVitals = (onPerfEntry = logMetric) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
